import { Injectable, inject } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as referenceSchemeActions from '../store/reference-scheme.actions';

@Injectable()
export class ReferenceSchemeOverviewResolver {
  private store = inject<Store<RootState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  resolve() {
    this.store.dispatch(referenceSchemeActions.loadData());
    return of(true);
  }
}
